import {faArrowLeft, faUser, faUserCog} from "@fortawesome/free-solid-svg-icons"
import {AppMenuItem} from "mixins/menu"
import React from "react"
import Navigation from "../../components/Navigation"
import NavigationItem from "../../components/NavigationItem"

class SettingsNavigation extends React.Component {
  menu: Array<AppMenuItem> = [
    {
      path: '/',
      icon: faArrowLeft,
      title: 'Zurück',
      visible: true
    },
    {
      icon: faUserCog,
      title: 'Einstellungen',
      visible: true
    },
    {
      path: '/settings',
      icon: faUser,
      title: 'Profil',
      visible: true
    },
  ]

  render() {
    return (
      <Navigation>
        {this.menu.map((item: AppMenuItem) => {
          return (
            <NavigationItem key={item.title} {...item} />
          )
        })
        }
      </Navigation>
    )
  }
}

export default SettingsNavigation
